import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Container,Row, Col } from 'react-bootstrap';

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Registrar"/>
            <section className="project-detail">
                <div className='container'>
                <div className="row">
                            
                            <div className="col-lg-10 col-md-12 col-sm-12">
                                <h3 className = "c-heading pb-30">Brig. Dr. K. P. Krishna Kumar (Retd.)</h3>
                                <p class="caboutus"><b>Brig. Dr. K. P. Krishna Kumar (Retd.)</b> is currently the Registrar of the Indian Institute of Technology (IIT) Tirupati, Andhra Pradesh. He brings with him over 35 years of distinguished service in the Indian Army, with extensive experience in Academics, Administration, Logistics, Equipment Management, and Human Resource Management.</p>
                                <p class="caboutus">He holds a Ph.D. in Computer Science from BITS Pilani and a Master’s degree in Computer Science from the Indian Institute of Science (IISc), Bengaluru. He has also acquired certifications in diverse domains such as Project Management, Supply Chain Management, Strategic Planning, and Aviation Technology & Management, underscoring his commitment to continuous learning.</p>
                                <p class="caboutus">During his military career, he played pivotal roles in institutional reforms and technology adoption. As the Registrar of IIT Tirupati, he brings the same rigor, strategic vision, and administrative acumen to support the institute’s mission of excellence in education, research, and innovation.</p>
                               

                                <div className="tm-highlight-block-new tm-highlight-right c-headline"><em> “Discipline, dedication, and purpose—cornerstones of every mission, military or academic.”</em></div>
                            </div>

                            <div className="col-lg-2 col-md-12 col-sm-12">
                                <div className="team-img-box">
                                    <Link to="/registrar">
                                        <img src="https://files.iittp.ac.in/images/demo/iit/registrar.jpg" alt="img" />
                                    </Link>
                                    <h3 className='c-headline text-center'></h3>
                                    <h3 className='c-headline text-center'>Registrar</h3>
                                    
                                </div>
                            </div>

                            
                        </div>
                    
                </div>
            </section>
        </>
    );
}

export default Main;